import {ChangeDetectionStrategy, Component, OnInit, OnDestroy, Input, Renderer2} from '@angular/core';

@Component({
  selector: 'v-cart-installment',
  templateUrl: './cart-installment.component.html',
  styleUrls: ['./cart-installment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CartInstallmentComponent implements OnInit, OnDestroy {
  @Input() installment;
  listener;

  constructor(private renderer2: Renderer2) {
  }

  ngOnInit() {
    this.initInstallment(this.installment);
  }

  async initInstallment(installment) {
    const options = {
      creditAmount: +installment.valueFormatted,
      posId: installment.posId,
      key: installment.key,
      showLongDescription: true
    }
    try {
      const results = await window['OpenPayU']?.Installments.miniInstallment('#payuinstallment', options);
      if(results.isWidgetAvailable) {
        const details = document.querySelector('.payu-mini-installments-widget-details');
        this.listener = this.renderer2.listen(details, 'click', event => event.preventDefault());
      }
    }
    catch (err) {
      console.error(err)
    }
  }

  ngOnDestroy() {
    this.listener();
  }

}
